import { useState, useEffect } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { Box, Page, Typography, Grid } from "@flukecorp-emu/common-ui";
import { AnalyticCard } from "../../components";
import taxonomyService from "../../services/taxonomyService";

export const Route = createFileRoute("/_authenticated/dashboard")({
  component: Dashboard,
});

function Dashboard() {
  const [taxonomyCount, setTaxonomyCount] = useState(0);

  useEffect(() => {
    const measures = taxonomyService.getAllMeasures();
    const sources = taxonomyService.getAllSources();
    const totalTaxonomy = measures.length + sources.length;
    setTaxonomyCount(totalTaxonomy);
  }, []);

  return (
    <Page title="Dashboard">
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Welcome to Fluke Admin
        </Typography>
        <Grid container rowSpacing={4.5} columnSpacing={2.75}>
          {/* row 1 */}
          <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
            <AnalyticCard title="Total Catalogs" count="10,000" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
            <AnalyticCard title="Taxonomy" count={taxonomyCount.toString()} />
          </Grid>
        </Grid>
      </Box>
    </Page>
  );
}
